import { render, staticRenderFns } from "./ImageProfile.vue?vue&type=template&id=46c9c963"
import script from "./ImageProfile.vue?vue&type=script&lang=ts"
export * from "./ImageProfile.vue?vue&type=script&lang=ts"
import style0 from "./ImageProfile.vue?vue&type=style&index=0&id=46c9c963&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports